"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconPet = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Pet" }, props),
        react_1.default.createElement("title", null, "Pet"),
        react_1.default.createElement("path", { d: "M99.996 58.436c6.314 0 11.433-5.119 11.433-11.432 0-6.314-5.119-11.433-11.433-11.433-6.313 0-11.432 5.119-11.432 11.433 0 6.313 5.119 11.432 11.433 11.432zM75.996 37.864c6.314 0 11.433-5.118 11.433-11.432S82.31 15 75.996 15c-6.313 0-11.432 5.118-11.432 11.432s5.119 11.432 11.432 11.432zM20.004 58.436c6.313 0 11.432-5.119 11.432-11.432 0-6.314-5.119-11.433-11.432-11.433-6.314 0-11.433 5.119-11.433 11.433 0 6.313 5.119 11.432 11.433 11.432zM44.004 37.864c6.313 0 11.432-5.118 11.432-11.432S50.317 15 44.004 15c-6.314 0-11.432 5.118-11.432 11.432s5.118 11.432 11.432 11.432z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M60 98.1L28.393 66.493l14.946-14.946c9.204-9.204 24.129-9.204 33.332 0l14.947 14.946L60 98.1z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M60 98.09c-8.732 8.731-22.875 8.731-31.607 0-8.732-8.733-8.732-22.876 0-31.608", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M60 98.09c8.732 8.731 22.875 8.731 31.607 0 8.732-8.733 8.732-22.876 0-31.608", fill: "#000" })));
};
exports.default = BrandIconPet;
